<template>
    <v-sheet color="bgtopology" class="adminview ma-4 pa-4" v-if="items.length > 0">
        <v-row justify="space-between" class="pb-6">

        <v-col class="px-6" cols="12" sm="4" md="3" lg="3" xl='2' align-self="center" >
            <v-btn block color="success" @click="showAddDialog()">
                <span class="text_btns">{{ t('buttons.add')}} </span>
            </v-btn>
        </v-col>
        
        <v-row class="ma-0" justify="end">
            <v-col class="px-6 pt-0" cols="12" sm="12" md="9" lg="9" xl='10' align-self="center">
                    <v-row class="ma-0" style="width: 100%;" justify="end">
                        <v-text-field
                        :style="!xs ? 'max-width: 400px !important; margin-top: 10px':'padding-top: 10px !important'"  
                        v-model="searchValue"
                        :label="t('search')"
                        variant="outlined"
                        density="compact"                      
                        hide-details                     
                        ></v-text-field>
                    </v-row>
            </v-col>
        </v-row>            
        </v-row>

        <v-dialog v-model="dialog" :width="width">
            <AdminDialog :itemObject="objectItem" @closeDialog="closeDialog()"/>
        </v-dialog>

        <EasyDataTable
        :search-field="searchField"
        :search-value="searchValue"
        table-class-name="customize-table"
        show-index
        :headers="headers"
        :items="items"
        >
        <template #item-operation="item">
            <div class="operation-wrapper">
                <v-icon color="blue" @click="showEditDialog(item)" > mdi-pencil-plus </v-icon>
                <v-icon color="red" @click="showDeleDialog(item)" > mdi-delete </v-icon>
            </div>
        </template>            
        </EasyDataTable>
    </v-sheet>
    <v-sheet v-else class="text-center">
        <Prog_circular/>
    </v-sheet>    
</template>

<script setup lang="ts">
import { computed, onMounted, Ref, ref, watch } from 'vue'

/********************************
 ********** COMPONENTES *********
 *******************************/
import Prog_circular from '@/components/PrincipalComponents/Prog_circular.vue';
import AdminDialog from '@/components/RAOS/Dialogs/AdminDialog.vue';

/********************************
 ********** INTERFACES **********
 *******************************/
import { HEADER } from '@/interfaces/SmartLink/Tables';


/********************************
 ************ STORE *************
 *******************************/
import { useStore } from 'vuex';
const store = useStore();

/********************************
 ************ I18N **************
 *******************************/
import { useI18n } from 'vue-i18n';
const { t } = useI18n();

/********************************
 *********** VUETIFY ************
 *******************************/
import { useDisplay } from 'vuetify';
const {xs, md,smAndDown } = useDisplay();


const headers = computed<HEADER[]>(() => [
    { text:  t('labels.name'), value: "nombre", sortable: true },
    { text:  t('labels.assigned'), value: "asignado", sortable: true },
    { text:  t('labels.turn'), value: "turno", sortable: true },
    { text:  t('labels.operation'), value: "operation", sortable: false},
])


/**
 * Sirve para buscar según que columnas, si no hay puesta ninguna, se busca en todas
 */
const searchField           = ref();


/**
 * Busca dentro de la tabla el valor que se escribe aquí
 */
const searchValue           = ref("");


/**
 * Ancho del dialogo, dependiendo del dispositivo donde se ve
 */
const width                 = computed(() => md.value?'60%':smAndDown.value?'85%':'900px');

/**
 * Mostrar el Dialogo
 */
const dialog                = ref(false);

const items   = computed(()=>store.state.arrayUserInfo);
// const showTable = ref(false)
/**
 * Objeto que inicializa el dialog al seleccionar alguna fila de la tabla
 */
const objectItem   = ref<any>({
    id      : 0,
    nombre : '',
    asignado : '',
    turno : '',
})


/**
 * Darle click al boton AGREGAR, abrira el dialog y agregara al objeto
 * "objectItem", el tipo de dialogo, en este caso: 'ADD'
 */
const showAddDialog     = () => { 
    objectItem.value['typeDialog']  = 'add';
    dialog.value                    = true;
}

/**
 * Darle click al boton EDITAR (lapiz), abrira el dialog 
 * Reemplaza el objeto "objectItem" con los valores de la fila seleccionada
 * y tambien agrega el tipo de dialogo, en este caso: 'EDIT'. 
 */
const showEditDialog    = (item:any) => {
    objectItem.value                = item ;
    objectItem.value['typeDialog']  = 'edit';
    dialog.value                    = true;
}

/**
 * Darle click al boton BORRAR (tacho), abrira el dialog 
 * Reemplaza el objeto "objectItem" con los valores de la fila seleccionada
 * y tambien agrega el tipo de dialogo, en este caso: 'DELETE'. 
 */
const showDeleDialog    = (item:any) => { 
    objectItem.value                = item ;
    objectItem.value['typeDialog']  = 'delete';
    dialog.value                    = true;
}

/**
 * Cierra el Diálogo cambiando el valor del dialog a FALSE
 */
const closeDialog       = () => {
    dialog.value    = false; 
}

function resetUser () {
    objectItem.value = {
        id : 0,
        nombre : '',
        asignado : '',
        turno : '',
    }
}

watch(dialog, (isOpen) => {
    !isOpen ? resetUser() : null;
})

onMounted(async () => {
    
    // headers.value = HEADERS_ADMIN['header']
    await store.dispatch('getAllUsers');
})

</script>